import React from 'react';
import {Modal, Button} from 'semantic-ui-react';

const MessageModal = ({displayMsg, open, setOpen, setParentModal}) => {
    return ( 
        <Modal
          onClose={() => setOpen(false)}
          open={open}
          size='small'
        >
          <Modal.Header>{displayMsg.title}</Modal.Header>
          <Modal.Content className="reconFileUploadContent">
            {displayMsg.message && <div className="create-job-messages" style={{color: displayMsg.color}}>{displayMsg.message}</div>}
          </Modal.Content>
          <Modal.Actions>
            <Button
              className="modal-recon-button"
              content='Close'
              onClick={() => {
                setOpen(false);
                if(displayMsg.color !== 'red')
                  setParentModal(false)
              }}
            />
          </Modal.Actions>
        </Modal>
     );
}
 
export default MessageModal;